import { Users, Groups } from "../sdk";

export class IRoles{

    private commercial = false;
    private logistic = false;
    private weigthControl = false;
    private qualityControl = false;
    private residueManager = false;
    private qualityUser = false;
    private homogenizationUser = false;
    private productionManager = false;
    private productionUser = false;
    private turnChief = false;
    private demoUser = false;

    constructor(user:Users){

        //buscar los roles de este usuario
        if(user && user.groups){
            for (let i = 0; i < user.groups.length; i++) {
                let group:Groups = user.groups[i];

                if(group && group.name){
                    switch(group.name){
                        case "Residue Manager":
                            this.residueManager = true;
                        break;

                        case "Commercial":
                            this.commercial = true;
                        break;

                        case "Logistic":
                            this.logistic = true;
                        break;

                        case "Weight Control":
                            this.weigthControl = true;
                        break;

                        case "Quality Control":
                            this.qualityControl = true;
                        break;

                        case "Demo User":
                            this.demoUser = true;
                            break;

                        case "Turn Chief":
                            this.turnChief = true;
                            break;

                        case "Production Manager":
                            this.productionManager = true;
                            break;

                        case "Production User":
                            this.productionUser = true;
                            break;

                        case "Quality User":
                            this.qualityUser = true;
                            break;

                        case "Homogenization User":
                            this.homogenizationUser = true;
                            break;
                    }

                }
            }
        }
    }


    public isCommercial():boolean{
        return this.commercial;
    }
    public isLogistic():boolean{
        return this.logistic;
    }
    public isWeightControl():boolean{
        return this.weigthControl;
    }
    public isQualityControl():boolean{
        return this.qualityControl;
    }
    public isResidueManager():boolean{
        return this.residueManager || this.demoUser;
    }
    public isPoQualityUser(): boolean {
        return this.qualityUser;
    }
    public isHomogenizationUser(): boolean {
        return this.homogenizationUser;
    }
    public isProductionManager(): boolean {
        return this.productionManager;
    }
    public isProductionUser(): boolean {
        return this.productionUser;
    }
    public isTurnChief(): boolean {
        return this.turnChief;
    }
}


// WEBPACK FOOTER //
// ./src/models/iRoles.ts